const doc = [({"ko":({"adminConstantHotelFilterType":({"meal":"식사", "planOption":"계획의 고집", "roomAmenity":"방 시설", "roomProperty":"방 고집"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;